document.addEventListener('DOMContentLoaded', function () {
  const gallery = document.querySelector('media-gallery');
  if (!gallery) return;

  const viewer = gallery.querySelector('[id^="GalleryViewer"]');

  function getMediaItems() {
    return Array.from(viewer.querySelectorAll('li[data-media-id]'));
  }

  function getActiveIndex(items) {
    return items.findIndex((el) => el.classList.contains('is-active'));
  }

  document.querySelectorAll('.gallery-nav-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const items = getMediaItems();
      const currentIndex = getActiveIndex(items);
      if (currentIndex === -1) return;

      const isPrev = btn.classList.contains('gallery-nav-btn--prev');
      let nextIndex = isPrev ? currentIndex - 1 : currentIndex + 1;

      // Loop
      if (nextIndex < 0) nextIndex = items.length - 1;
      if (nextIndex >= items.length) nextIndex = 0;

      const nextMediaId = items[nextIndex].dataset.mediaId;
      const scrollY = window.scrollY;
      gallery.setActiveMedia(nextMediaId, false);

      requestAnimationFrame(() => {
        window.scrollTo({ top: scrollY, behavior: 'instant' });
      });
    });
  });
});

